<p-toast></p-toast>

<!-- =========================================================
     HERO — role identity + progress
     ========================================================= -->
<section class="detail-hero" *ngIf="role">
  <button type="button" class="back-btn" (click)="cancel()">
    <i class="pi pi-arrow-right"></i>
    <span>الأدوار</span>
  </button>

  <div class="detail-hero-main">
    <div class="detail-icon" [class]="systemTheme.themeClass">
      <i [class]="systemTheme.icon"></i>
    </div>
    <div class="detail-text">
      <div class="eyebrow eyebrow-light">
        <i class="pi pi-shield"></i>
        <span>إدارة صلاحيات الدور</span>
      </div>
      <div class="title-row">
        <h1 class="detail-title">{{ role.name }}</h1>
        <span class="scope-chip" [class]="systemTheme.themeClass">
          <i [class]="systemTheme.icon"></i>
          {{ role.systemKey || 'Global' }}
        </span>
      </div>
      <p class="role-desc" *ngIf="role.description">{{ role.description }}</p>
    </div>
  </div>

  <div class="progress-block">
    <div class="progress-num">
      <span class="big">{{ totalSelected }}</span>
      <span class="of">/ {{ totalAvailable }}</span>
    </div>
    <div class="progress-bar">
      <div class="progress-fill" [style.width.%]="progressPercent"></div>
    </div>
    <div class="progress-lbl">
      <span>{{ progressPercent }}% مفعّلة</span>
      <span class="dirty-flag" *ngIf="hasChanges">
        <i class="pi pi-circle-fill"></i>
        تغييرات غير محفوظة
      </span>
    </div>
  </div>
</section>

<!-- =========================================================
     TOOLBAR — search + system filter + bulk actions
     ========================================================= -->
<div class="toolbar" *ngIf="!loading">
  <div class="filters">
    <span class="p-input-icon-left search-wrap">
      <i class="pi pi-search"></i>
      <input
        pInputText
        [(ngModel)]="search"
        placeholder="ابحث عن مورد أو فعل..."
      />
    </span>

    <div class="system-chips" *ngIf="systems.length > 1">
      <button
        type="button"
        class="chip-btn"
        [class.active]="!systemFilter"
        (click)="systemFilter = ''"
      >
        كل الأنظمة
      </button>
      <button
        type="button"
        *ngFor="let s of systems"
        class="chip-btn"
        [class.active]="systemFilter === s"
        (click)="systemFilter = s"
      >
        {{ s }}
      </button>
    </div>

    <button
      *ngIf="search || systemFilter"
      pButton
      icon="pi pi-filter-slash"
      label="مسح الفلاتر"
      class="p-button-text btn-clear"
      (click)="clearFilters()"
    ></button>
  </div>

  <div class="actions-bar">
    <button
      pButton
      [label]="'تحديد المعروض (' + totalVisible + ')'"
      icon="pi pi-check-square"
      class="p-button-text"
      [disabled]="totalVisibleSelected === totalVisible"
      (click)="selectAllVisible()"
    ></button>
    <button
      pButton
      label="إلغاء التحديد"
      icon="pi pi-stop"
      class="p-button-text"
      [disabled]="totalVisibleSelected === 0"
      (click)="clearAllVisible()"
    ></button>
    <span class="sep-vert"></span>
    <button
      pButton
      label="فتح الكل"
      icon="pi pi-angle-double-down"
      class="p-button-text"
      (click)="expandAll()"
    ></button>
    <button
      pButton
      label="طي الكل"
      icon="pi pi-angle-double-up"
      class="p-button-text"
      (click)="collapseAll()"
    ></button>
  </div>
</div>

<!-- =========================================================
     LOADING SKELETON
     ========================================================= -->
<div class="picker-skeleton" *ngIf="loading">
  <div class="sys-skel" *ngFor="let i of [1,2,3,4]"></div>
</div>

<!-- =========================================================
     GROUPS
     ========================================================= -->
<div class="groups-list" *ngIf="!loading">
  <div
    class="group-card"
    *ngFor="let g of visibleGroups; trackBy: trackGroup"
    [class.is-open]="g.expanded"
    [class.has-selection]="groupSelectedCount(g) > 0"
    [class.is-full]="isGroupAllSelected(g)"
  >
    <div class="group-header">
      <div class="group-checkbox" (click)="$event.stopPropagation()">
        <p-checkbox
          [binary]="true"
          [ngModel]="isGroupAllSelected(g)"
          (onChange)="toggleGroup(g, $event.checked)"
          [styleClass]="isGroupPartial(g) ? 'cb-partial' : ''"
        ></p-checkbox>
      </div>

      <div class="group-body-clickable" (click)="g.expanded = !g.expanded">
        <div class="group-icon">
          <i [class]="g.icon"></i>
        </div>
        <div class="group-meta">
          <div class="group-title-row">
            <span class="sys-chip">{{ g.system }}</span>
            <span class="res-name">{{ g.label }}</span>
            <code class="res-code">{{ g.resource }}</code>
          </div>
          <div class="group-verbs" *ngIf="!g.expanded">
            <span
              class="verb-mini"
              *ngFor="let a of g.actions; trackBy: trackAction"
              [ngClass]="verbTone(a.action)"
              [class.is-on]="a.selected"
              [pTooltip]="a.displayNameAr || a.displayNameEn || a.key"
              tooltipPosition="top"
            >
              {{ a.action }}
            </span>
          </div>
        </div>
        <div class="group-side">
          <span class="count-badge" [class.full]="isGroupAllSelected(g)">
            <span class="count-sel">{{ groupSelectedCount(g) }}</span>
            <span class="count-of">/</span>
            <span class="count-total">{{ g.actions.length }}</span>
          </span>
          <i class="pi chevron" [class.pi-chevron-up]="g.expanded" [class.pi-chevron-down]="!g.expanded"></i>
        </div>
      </div>
    </div>

    <div class="group-body" *ngIf="g.expanded">
      <div class="actions-grid">
        <label
          class="action-row"
          *ngFor="let a of g.actions; trackBy: trackAction"
          [class.checked]="a.selected"
        >
          <p-checkbox [binary]="true" [(ngModel)]="a.selected"></p-checkbox>
          <div class="action-info">
            <div class="action-name">
              <span class="verb-chip" [ngClass]="verbTone(a.action)">{{ a.action }}</span>
              <span class="ar-name" *ngIf="a.displayNameAr">{{ a.displayNameAr }}</span>
            </div>
            <code class="action-key">{{ a.key }}</code>
          </div>
        </label>
      </div>
    </div>
  </div>

  <div class="empty-state" *ngIf="visibleGroups.length === 0">
    <div class="empty-illust"><i class="pi pi-search"></i></div>
    <h3>لا توجد صلاحيات تطابق البحث</h3>
    <p>جرّب مسح الفلاتر لرؤية كل الصلاحيات.</p>
  </div>
</div>

<!-- =========================================================
     STICKY SAVE BAR
     ========================================================= -->
<div class="save-bar" *ngIf="!loading && hasChanges">
  <div class="save-bar-inner">
    <div class="delta">
      <span class="delta-chip delta-add" *ngIf="netDelta.added > 0">
        <i class="pi pi-plus"></i>
        +{{ netDelta.added }} مضافة
      </span>
      <span class="delta-chip delta-rem" *ngIf="netDelta.removed > 0">
        <i class="pi pi-minus"></i>
        −{{ netDelta.removed }} محذوفة
      </span>
    </div>
    <div class="save-actions">
      <button
        pButton
        label="تراجع عن التغييرات"
        icon="pi pi-undo"
        class="p-button-text"
        [disabled]="saving"
        (click)="resetChanges()"
      ></button>
      <button
        pButton
        label="إلغاء"
        class="p-button-secondary"
        [disabled]="saving"
        (click)="cancel()"
      ></button>
      <button
        pButton
        label="حفظ التغييرات"
        icon="pi pi-save"
        class="save-btn"
        [loading]="saving"
        (click)="save()"
      ></button>
    </div>
  </div>
</div>
